import { forwardRef } from 'react'
import { cn } from '../utils/cn.ts'
import { Avatar } from '../components/Avatar.tsx'
import { Badge } from '../components/Badge.tsx'

export interface GuestListItemProps {
  name: string
  avatarSrc?: string
  rsvpStatus: 'rsvp-going' | 'rsvp-cant-go' | 'invited'
  paymentStatus?: 'payment-paid' | 'payment-unpaid'
  className?: string
}

export const GuestListItem = forwardRef<HTMLDivElement, GuestListItemProps>(
  ({ name, avatarSrc, rsvpStatus, paymentStatus, className }, ref) => (
    <div ref={ref} className={cn('guest-list-item', className)}>
      <Avatar name={name} size="sm" src={avatarSrc} />
      <span className="guest-list-item-name">{name}</span>
      <Badge variant={rsvpStatus} />
      {paymentStatus && <Badge variant={paymentStatus} />}
    </div>
  ),
)
GuestListItem.displayName = 'GuestListItem'
